import {
  EntityLayoutSkeleton,
  OverviewPanelSkeleton,
  TabsSkeleton,
} from "@project/components/feedback";
import {Skeleton} from "@project/design-system-web";

export function RepresentativePending() {
  return (
    <EntityLayoutSkeleton>
      <EntityLayoutSkeleton.Sidebar>
        <OverviewPanelSkeleton>
          <OverviewPanelSkeleton.Header>
            <Skeleton className="size-20 shrink-0 rounded-full" />
            <div className="flex min-w-0 flex-1 flex-col gap-2">
              <div className="flex min-w-0 flex-col gap-1">
                <Skeleton className="h-6 w-48 rounded-md" />
              </div>
              <Skeleton className="h-5 w-16 rounded-md" />
            </div>
          </OverviewPanelSkeleton.Header>
          <OverviewPanelSkeleton.Content>
            <div className="pb-4">
              <dl className="flex flex-col gap-4">
                {Array.from({length: 5}).map((_, i) => (
                  <OverviewPanelSkeleton.Field key={i} />
                ))}
              </dl>
            </div>
          </OverviewPanelSkeleton.Content>
          + +{" "}
          <OverviewPanelSkeleton.Footer>
            + <OverviewPanelSkeleton.FooterItem />
            + <OverviewPanelSkeleton.FooterItem />+{" "}
          </OverviewPanelSkeleton.Footer>
        </OverviewPanelSkeleton>
      </EntityLayoutSkeleton.Sidebar>
      <EntityLayoutSkeleton.Main>
        <EntityLayoutSkeleton.DesktopNav>
          <TabsSkeleton tabs={2} />
        </EntityLayoutSkeleton.DesktopNav>
        <EntityLayoutSkeleton.MobileNav>
          <Skeleton className="h-10 w-full rounded-md" />
        </EntityLayoutSkeleton.MobileNav>
        <EntityLayoutSkeleton.Content>
          <div className="flex h-full w-full flex-col gap-4">
            <Skeleton className="h-full min-h-75 w-full rounded-xl" />
          </div>
        </EntityLayoutSkeleton.Content>
      </EntityLayoutSkeleton.Main>
    </EntityLayoutSkeleton>
  );
}
